import React from "react";
import Image from "next/image";
import block from "bem-css-modules";
import card from "../../styles/components/Employeecard.module.scss";

export default function EmployeeCard({
  spaceTop,
  spaceBottom,
  employeeDetails,
}) {
  block.setSettings({
    modifierDelimiter: "--",
  });

  const employee = block(card);
  return (
    <div className={employee("")}>
      <div
        className={
          `${employee("wrapper")}` +
          " " +
          `${spaceTop && employee("wrapper--spaceTop")}` +
          " " +
          `${spaceBottom && employee("wrapper--spaceBottom")}`
        }
      >
        <section className={employee("row")}>
          <div className={employee("image")}>
            <Image
              src={employeeDetails.Image.url}
              alt={"testimonial"}
              width={160}
              height={160}
              layout="responsive"
              className={employee("employeeImage")}
            />
          </div>
          <div className={employee("details")}>
            <h3 className={employee("head")}>{employeeDetails.Name}</h3>

            <div
              className={employee("text")}
              dangerouslySetInnerHTML={{
                __html: employeeDetails.Information,
              }}
            ></div>
            {/* <p className={employee("text")}>
              {employeeDetails.Description}
            </p> */}
          </div>
        </section>
      </div>
    </div>
  );
}
